module.exports = __webpack_public_path__ + "static/img/sjtj_spot.72df10cc.svg";